/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ResourceRecommendationStatus {
    open = 'open',
    system_skipped = 'system_skipped',
    user_rejected = 'user_rejected',
    resolve_validation_pending = 'resolve_validation_pending',
    resolved = 'resolved',
    closed = 'closed'
}
